import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlignTypes } from '@monorepo-web/components-library';
import { auxFormatPercent, FormatTypes, groupAndSumByProperties, helperFormat, hexToRGBA, } from '@monorepo-web/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
export function getColumnsRetornosAtivos(preferenceCustomizacao) {
    var _a;
    const columnsRetornos = [
        {
            id: 'nome_ativo',
            label: 'Ativo',
            colorLegend: true,
            freeze: true,
            width: '300px',
            noBreak: true,
        },
        {
            id: 'Ret_Mes',
            label: 'Mês',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_Ano',
            label: 'Ano',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_3m',
            label: '3 meses',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_6m',
            label: '6 meses',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_12m',
            label: '12 meses',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_24m',
            label: '24 meses',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_36m',
            label: '36 meses',
            align: AlignTypes.right,
        },
        {
            id: 'Ret_periodo',
            label: 'Desde a compra',
            align: AlignTypes.right,
        },
        {
            id: 'data_compra',
            label: 'Data Compra',
            align: AlignTypes.right,
        },
        {
            id: 'percent_sli',
            label: (_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.PosCon_headerPercent) !== null && _a !== void 0 ? _a : '%',
            align: AlignTypes.right,
        },
    ];
    return columnsRetornos;
}
export function formatRowsRetornosAtivos(retornos_ativos, preferenceCustomizacao, theme, dispatchPDF, onRowClickHandle, setNomeAtivoModal, dados_ativos_agrupados) {
    const rowsRetornosAtivos = [];
    let retornoAtivoAtualizado = retornos_ativos;
    // Layout 'retorno_ativo_saldo_bruto' tem coluna de Saldo Bruto
    if (preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.RetAtivo_comSaldoBruto) {
        const dadosAtivosMap = new Map(dados_ativos_agrupados === null || dados_ativos_agrupados === void 0 ? void 0 : dados_ativos_agrupados.map((item) => [item.nome_ativo, item.sbr_fim]));
        retornoAtivoAtualizado = retornos_ativos === null || retornos_ativos === void 0 ? void 0 : retornos_ativos.map((item) => {
            const sbr_fim = dadosAtivosMap.get(item.nome_ativo);
            return sbr_fim !== undefined ? Object.assign(Object.assign({}, item), { sbr_fim }) : item;
        });
    }
    const retornosAtivos = retornoAtivoAtualizado
        ? groupAndSumByProperties(retornoAtivoAtualizado, "classe", "subclasse", ["percent_sli"])
        : [];
    retornosAtivos === null || retornosAtivos === void 0 ? void 0 : retornosAtivos.forEach((classe, index) => {
        // linha classe
        if (classe.class)
            rowsRetornosAtivos.push({
                nome_ativo: classe.class,
                colorIndex: index,
                bgColor: theme.classColor,
                color: theme.backgroundColor,
                bold: true,
                Ret_Mes: '',
                Ret_Ano: '',
                Ret_3m: '',
                Ret_6m: '',
                Ret_12m: '',
                Ret_24m: '',
                Ret_36m: '',
                Ret_periodo: '',
                data_compra: '',
                percent_sli: '',
                sbr_fim: '',
                openModal: null,
            });
        classe.subclasses.forEach((subclasse) => {
            // linha subclasse
            if (subclasse.subclass)
                rowsRetornosAtivos.push({
                    nome_ativo: subclasse.subclass,
                    bgColor: '#E7E7E7',
                    color: theme.fontColor,
                    bold: true,
                    colorIndex: index,
                    Ret_Mes: '',
                    Ret_Ano: '',
                    Ret_3m: '',
                    Ret_6m: '',
                    Ret_12m: '',
                    Ret_24m: '',
                    Ret_36m: '',
                    Ret_periodo: '',
                    data_compra: '',
                    percent_sli: '',
                    sbr_fim: '',
                    openModal: null,
                });
            subclasse.values.forEach((ativo) => {
                var _a, _b, _c;
                // ativo
                rowsRetornosAtivos.push({
                    nome_ativo: ((_a = ativo.chave_para_modal) === null || _a === void 0 ? void 0 : _a.data_compra_AAAAmmDD) && !dispatchPDF ? (_jsxs("span", { children: [_jsx(FontAwesomeIcon, { icon: faMagnifyingGlass, style: { marginRight: 4 } }), ativo.nome_ativo] })) : (ativo.nome_ativo),
                    Ret_Mes: helperFormat(ativo.Ret_Mes, FormatTypes.decimals, 2),
                    Ret_Ano: helperFormat(ativo.Ret_Ano, FormatTypes.decimals, 2),
                    Ret_3m: helperFormat(ativo.Ret_3m, FormatTypes.decimals, 2),
                    Ret_6m: helperFormat(ativo.Ret_6m, FormatTypes.decimals, 2),
                    Ret_12m: helperFormat(ativo.Ret_12m, FormatTypes.decimals, 2),
                    Ret_24m: helperFormat(ativo.Ret_24m, FormatTypes.decimals, 2),
                    Ret_36m: helperFormat(ativo.Ret_36m, FormatTypes.decimals, 2),
                    Ret_periodo: helperFormat(ativo.Ret_periodo, FormatTypes.decimals, 2),
                    data_compra: helperFormat(ativo.data_compra, FormatTypes.text),
                    percent_sli: helperFormat(auxFormatPercent(ativo.percent_sli), FormatTypes.decimals, 2),
                    sbr_fim: helperFormat(ativo.sbr_fim, FormatTypes.decimals, 2),
                    colorIndex: index,
                    openModal: ((_b = ativo.chave_para_modal) === null || _b === void 0 ? void 0 : _b.data_compra_AAAAmmDD)
                        ? () => {
                            onRowClickHandle(ativo.chave_para_modal);
                            setNomeAtivoModal(ativo.nome_ativo);
                        }
                        : null,
                    chave_para_modal: ativo.chave_para_modal,
                });
                if (!((_c = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.RetAtivo_removerLinhaPercentCDI) !== null && _c !== void 0 ? _c : false) &&
                    ativo.retornos_benchmarks &&
                    ativo.retornos_benchmarks.length > 0) {
                    for (let i = 0; i < ativo.retornos_benchmarks.length; i++) {
                        rowsRetornosAtivos.push({
                            nome_ativo: ativo.retornos_benchmarks[i].nome_benchmark.replace(/Percent /i, '%'),
                            Ret_Mes: helperFormat(ativo.retornos_benchmarks[i].Ret_Mes_benchmark, FormatTypes.decimals, 2),
                            Ret_Ano: helperFormat(ativo.retornos_benchmarks[i].Ret_Ano_benchmark, FormatTypes.decimals, 2),
                            Ret_3m: helperFormat(ativo.retornos_benchmarks[i].Ret_3m_benchmark, FormatTypes.decimals, 2),
                            Ret_6m: helperFormat(ativo.retornos_benchmarks[i].Ret_6m_benchmark, FormatTypes.decimals, 2),
                            Ret_12m: helperFormat(ativo.retornos_benchmarks[i].Ret_12m_benchmark, FormatTypes.decimals, 2),
                            Ret_24m: helperFormat(ativo.retornos_benchmarks[i].Ret_24m_benchmark, FormatTypes.decimals, 2),
                            Ret_36m: helperFormat(ativo.retornos_benchmarks[i].Ret_36m_benchmark, FormatTypes.decimals, 2),
                            Ret_periodo: helperFormat(ativo.retornos_benchmarks[i].Ret_periodo_benchmark, FormatTypes.decimals, 2),
                            data_compra: '-',
                            percent_sli: '-',
                            sbr_fim: helperFormat(ativo.sbr_fim, FormatTypes.decimals, 2),
                            colorIndex: index,
                        });
                    }
                }
            });
            // total subclasse
            if (subclasse.subclass)
                rowsRetornosAtivos.push({
                    nome_ativo: `Total ${subclasse.subclass}`,
                    Ret_Mes: '',
                    Ret_Ano: '',
                    Ret_3m: '',
                    Ret_6m: '',
                    Ret_12m: '',
                    Ret_24m: '',
                    Ret_36m: '',
                    Ret_periodo: '',
                    data_compra: '',
                    percent_sli: helperFormat(auxFormatPercent(subclasse.subtotal.percent_sli), FormatTypes.decimals, 2),
                    sbr_fim: '',
                    colorIndex: index,
                    // bgColor: theme.chartLighterColors[index % theme.chartLighterColors.length],
                    bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLighter),
                    color: theme.fontColor,
                    bold: true,
                    openModal: null,
                });
        });
        // total classe
        if (classe.class)
            rowsRetornosAtivos.push({
                nome_ativo: `Total ${classe.class}`,
                Ret_Mes: '',
                Ret_Ano: '',
                Ret_3m: '',
                Ret_6m: '',
                Ret_12m: '',
                Ret_24m: '',
                Ret_36m: '',
                Ret_periodo: '',
                data_compra: '',
                percent_sli: helperFormat(auxFormatPercent(classe.subtotal.percent_sli), FormatTypes.decimals, 2),
                sbr_fim: '',
                colorIndex: index,
                // bgColor: theme.chartLightColors[index % theme.chartLightColors.length],
                bgColor: hexToRGBA(theme.chartColors[index % theme.chartColors.length], theme.hexAlphaLight),
                color: theme.fontColor,
                bold: true,
                openModal: null,
            });
    });
    return rowsRetornosAtivos;
}
